<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
    <header class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div class="min-w-0">
        <h1 class="text-xl sm:text-2xl font-semibold text-gray-900">RIB</h1>
        <p class="text-sm text-gray-500 mt-1">Relevés d'identité bancaire de votre entreprise.</p>
      </div>
      <label class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-4 py-2.5 sm:py-2 bg-secondary text-white text-sm font-medium rounded-md cursor-pointer hover:bg-secondary-hover shrink-0">
        <span class="material-symbols-outlined text-[16px]">upload</span>
        Ajouter un RIB
        <input class="hidden" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="upload($event)">
      </label>
    </header>

    <article class="rounded-xl border border-gray-200 bg-white p-3 shadow-sm min-w-0 overflow-hidden">
      @if (loading()) {
        <p class="text-sm text-gray-500 p-4">Chargement...</p>
      } @else if (!files().length) {
        <div class="p-5 text-sm text-gray-500 flex items-center gap-2">
          <span class="material-symbols-outlined">account_balance</span>
          Aucun RIB n'est disponible pour le moment.
        </div>
      } @else {
        <ul class="divide-y divide-gray-100">
          @for (file of files(); track file.id) {
            <li class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-3">
              <div class="min-w-0">
                <p class="font-medium text-sm text-gray-900 break-words">{{ file.originalFilename }}</p>
                <p class="text-xs text-gray-500">{{ file.createdAt | date: 'dd/MM/yyyy HH:mm' }}</p>
              </div>
              <button
                class="w-full sm:w-auto rounded-md border border-gray-300 px-3 py-2 sm:py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
                (click)="download(file.id)"
              >
                Télécharger
              </button>
            </li>
          }
        </ul>
      }
    </article>
  </div>
</section>
